import type { LeadTimeRecordType, LeadTimeItemType, LeadTimesTableData } from '@/types/CM/leadTimes'
import { dateTimeNzFormat } from '@/helpers/genericFormatting'

export function getJobProfilesFromLeadTimes (leadTimes: LeadTimeRecordType[]): string[] {
  const JobProfilesArray = leadTimes.map(leadTime => leadTime.job_profile)
  const uniqueJobProfiles = [...new Set(JobProfilesArray)].sort()
  return [...uniqueJobProfiles]
}

export function getExchangesFromLeadTimes (leadTimes: LeadTimeRecordType[]): string[] {
  const exchangesArray = leadTimes.map(leadTime => leadTime.exchange)
  const uniqueExchanges = [...new Set(exchangesArray)].sort()
  return [...uniqueExchanges]
}

/**
 * Get the data for the lead times table
 * @param leadTimes
 */
export function getLeadTimesTableData (leadTimes: LeadTimeRecordType[]): LeadTimeItemType[] {
  const exchanges = getExchangesFromLeadTimes(leadTimes)
  const jobProfiles = getJobProfilesFromLeadTimes(leadTimes)
  const leadTimesTableData = [] as LeadTimeItemType[]

  exchanges.forEach(exchange => {
    jobProfiles.forEach(jobProfile => {
      const leadTime = leadTimes.find(leadTime => {
        return leadTime.exchange === exchange && leadTime.job_profile === jobProfile
      })
      let id = ''
      let leadTimeHours = 0
      let leadTimeMinutes = 0
      let nextAvailableTimeslot = '-'

      if (leadTime) {
        const leadTimeInMinutes = leadTime.leadTime
        leadTimeHours = Math.floor(leadTimeInMinutes / 60)
        leadTimeMinutes = leadTimeInMinutes % 60
        id = leadTime.id
        nextAvailableTimeslot = leadTime.nextAvailableTimeslot
      }

      leadTimesTableData.push({
        id,
        exchange,
        jobProfile,
        nextAvailableTimeslot,
        leadTimeHours,
        leadTimeMinutes
      })
    })
  })
  return leadTimesTableData
}

export function prepareLeadTimeTableData (newLeadTimeCells: LeadTimeItemType[]): LeadTimesTableData {
  return newLeadTimeCells.reduce((acc, cell) => {
    acc[`${cell.exchange}-${cell.jobProfile}`] = {
      hours: cell.leadTimeHours,
      minutes: cell.leadTimeMinutes,
      nextAvailableTimeslot: dateTimeNzFormat(cell.nextAvailableTimeslot)
    }
    return acc
  }, {} as LeadTimesTableData)
}
